const PasswordField = ({ label, value, onChange, visible, onToggle }) => (
  <div className="user-profile-field-block">
    <p className="">{label}</p>
    <div className="row">
      <div className="col-sm-8">
        <input
          type={visible ? "text" : "password"}
          className="form-control"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <div className="col-sm-1 text-left user-profile-eye-wrap">
        <button type="button" className="user-profile-eye-btn" onClick={onToggle}>
          <span className="glyphicon glyphicon-eye-open" />
        </button>
      </div>
    </div>
  </div>
);

const ChangePasswordPanel = ({
  profileType,
  currentPassword,
  newPassword,
  confirmPassword,
  showCurrent,
  showNew,
  showConfirm,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onToggleCurrent,
  onToggleNew,
  onToggleConfirm,
  onSubmit,
  onCancel,
  showPostSuccessPrompt,
  onPostSuccessYes,
  onPostSuccessNo,
}) => {
  const isForgot = profileType === "ChangeForgotPassword";
  const isFromProfilePassword = profileType === "ChangePassword";

  return (
    <div>
      {!showPostSuccessPrompt && (
        <div id="passwordDiv">
          <h3>Change Your Password</h3>

          {isForgot && (
            <div className="user-profile-info-msg">
              <p>Set up a new password before continuing.</p>
            </div>
          )}

          {!isForgot && !isFromProfilePassword && (
            <div className="user-profile-info-msg">
              <p>You are currently using a temporary password to login. You are required to set up a new password before continuing.</p>
            </div>
          )}

          {/* {isFromProfilePassword && <PasswordField
            label={"Current Password:"}
            value={currentPassword}
            onChange={onCurrentPasswordChange}
            visible={showCurrent}
            onToggle={onToggleCurrent}
          /> } */}

          <PasswordField
            label="Enter New Password:"
            value={newPassword}
            onChange={onNewPasswordChange}
            visible={showNew}
            onToggle={onToggleNew}
          />

          <PasswordField
            label="Confirm New Password:"
            value={confirmPassword}
            onChange={onConfirmPasswordChange}
            visible={showConfirm}
            onToggle={onToggleConfirm}
          />

          <div className="user-profile-actions">
            <button type="button" className="btn btn-primary btn_profile" onClick={onSubmit}>Submit</button>
            <button type="button" className="btn btn-primary btn_profile" onClick={onCancel}>Cancel</button>
          </div>
        </div>
      )}

      {showPostSuccessPrompt && (
        <div id="updatePasswordMsgDiv" className="user-profile-post-password-msg">
          <p>Thank you. Your password has been updated.</p>
          <p>Would you like to update your security questions/answers?</p>
          <div className="user-profile-actions">
            <button type="button" className="btn btn-primary btn_profile" onClick={onPostSuccessYes}>Yes</button>
            <button type="button" className="btn btn-primary btn_profile" onClick={onPostSuccessNo}>No</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangePasswordPanel;
